import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { Amplify, Auth } from "aws-amplify";
import awsExports from "./aws-exports";
import { PersistGate } from "redux-persist/integration/react";

const redirectUrl = `${window.location.origin}/`;

const amplifyConfig = {
  ...awsExports,
  oauth: {
    ...awsExports.oauth,
    scope: ["openid", "email", "profile"],
    redirectSignIn: redirectUrl,
    redirectSignOut: redirectUrl,
    responseType: "code",
  },
};

Amplify.configure(amplifyConfig);
Auth.configure(amplifyConfig);

// Inject robots meta tag dynamically for dev/test environments
if (process.env.NODE_ENV !== "prod") {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow";
  document.head.appendChild(meta);
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
